import React, { useState, Suspense, useReducer } from 'react';
import { Snackbar } from '@mui/material'
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';
import { LOCAL_STORAGE_KEY } from '../constants/localStorage';


const ZulassungsContext = React.createContext();

function reducer(state, action) {
  switch (action.type) {
    case 'changePrograms':
      localStorage.setItem(LOCAL_STORAGE_KEY.programs, JSON.stringify(action.programs));
      return {
        programs: action.programs,
        mandant: state.mandant,
        newsAmount: state.newsAmount
      }
    case "changeMandant":
      localStorage.setItem(LOCAL_STORAGE_KEY.client, action.mandant);
      return {
        programs: state.programs,
        mandant: action.mandant,
        newsAmount: state.newsAmount
      }
    case "changeNewsAmount":
      localStorage.setItem(LOCAL_STORAGE_KEY.newsAmount, action.newsAmount);
      return {
        programs: state.programs,
        mandant: state.mandant,
        newsAmount: action.newsAmount
      }
    case "resetZulassung":
      localStorage.setItem(LOCAL_STORAGE_KEY.client, "");
      localStorage.setItem(LOCAL_STORAGE_KEY.programs, "[]");
      localStorage.setItem(LOCAL_STORAGE_KEY.newsAmount, 0);
      return {
        programs: [],
        mandant: "",
        newsAmount: 0
      }
    default:
      throw Error('Unknown action.');
  }
}

const ZulassungsProvider = (props) => {
  const [zulassung, dispatch] = useReducer(reducer, { mandant: localStorage.getItem(LOCAL_STORAGE_KEY.client), programs: [], newsAmount: 0 });

  console.log(zulassung)


  const updatePrograms = (newPrograms) => {
    dispatch({ type: 'changePrograms', programs: newPrograms })
  }

  const updateMandant = (mandant) => {
    dispatch({ type: 'changeMandant', mandant: mandant });
  }

  const updateNewsAmount = (newsAmount) => {
    dispatch({ type: 'changeNewsAmount', newsAmount: newsAmount });
  }

  const resetZulassung = () => {
    dispatch({ type: 'resetZulassung' });
  }

  return <ZulassungsContext.Provider value={{ updatePrograms, updateMandant, updateNewsAmount, resetZulassung, zulassung }}>{props.children}</ZulassungsContext.Provider>
}

const useZulassung = () => {
  const context = React.useContext(ZulassungsContext);
  if (context === undefined) {
    throw new Error('useZulassung must be used within a ZulassungsProvider');
  }
  return context;
}

export { ZulassungsProvider, useZulassung }